export default [
    { value: "1", label: "Intern" },
    { value: "2", label: "Contract" },
    { value: "3", label: "Part Time" },
    { value: "4", label: "Full Time"},
    { value: "5", label: "Expression of Interest"},
    { value: "6", label: "Temporary"}
  ];